import axios, {
  AxiosRequestConfig,
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { ElMessage, ElNotification } from "element-plus";
import { getUserInfo, getApiBaseUrl } from "../utils/index";
import router from "../router/index";

export const timeout = 300000; // 300秒

const config: AxiosRequestConfig = {
  timeout,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  },
  // 这里配置为 true，所有请求均不会被 Axios rejected
  validateStatus() {
    return true;
  },
  responseType: "json",
  baseURL: getApiBaseUrl(),
};

const instance: AxiosInstance = axios.create(config);

// 请求拦截器
instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getUserInfo()?.token;
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// 响应：业务数据层格式兼容处理
instance.interceptors.response.use(async (res: AxiosResponse) => {
  if (res?.status === 401) {
    localStorage.removeItem("userInfo");
    ElMessage.error(res?.data.message || "未授权");
    router.push("/login");
    return;
  }

  // 1. 统一处理 Blob 响应（无论 status 是什么）
  if (res.data instanceof Blob) {
    try {
      const text = await res.data.text();
      const data = JSON.parse(text); // 尝试解析为 JSON

      // 如果解析成功且是错误信息（如 {code: "error"}）
      if (data.code === "error") {
        ElNotification.error({ title: data.message || "请求失败" });
        return data;
      }
    } catch (e) {
      // 解析失败说明是真正的文件流
      return { code: "success", content: res.data, message: "" }; // 返回原始响应（含 Blob）
    }
  }

  if (res.status !== 200) {
    const errorMessage = res.data?.message || res.statusText || "请求错误";
    ElNotification({
      title: errorMessage,
      type: "error",
    });
    return Promise.reject(res.data ?? { message: errorMessage });
  }

  if (!res.data?.code) {
    return { code: "error", content: res.data, message: "" };
  }
  return res.data;
});
export default instance;
